<div class="courses-list" *ngIf="courses">
  <ng-container *ngFor="let course of courses; let last = last">
    <div class="course-row" (click)="handleCourseClick(course)">
      <div class="general-info">
        <i-tabler name="folder" [style.stroke]="course.color"></i-tabler>
        <h2 class="name">{{course.name}}</h2>
      </div>

      <div class="actions-container">
        <i-tabler name="pencil" class="action-icon" (click)="editCourse($event, course)"></i-tabler>
      </div>

      <!--<div *ngIf="course.openCards > 0" class="repetition-info">
        <div class="repeat-container">
          <i class="fas fa-repeat"></i>
          <span class="repeat-count">{{course.openCards}}</span>
        </div>
      </div>-->

      <i-tabler name="chevron-right"></i-tabler>
    </div>
    <div *ngIf="!last" class="divider"></div>
  </ng-container>
</div>

<app-bottom-dialog [isVisible]="editCourseVisible" [title]="'Kurs bearbeiten'" (close)="editCourseVisible = false" (actionCancelled)="editCourseVisible = false">
  <app-edit-course [course]="courseToEdit" (finished)="editCourseVisible = false"></app-edit-course>
</app-bottom-dialog>
